import { useNavigate } from "@solidjs/router";
import { createSignal, Show, createMemo } from "solid-js";
import { registerUser } from "../../services/registerService";
import Loading from "../Loading";

export default function RegisterForm() {
  const nav = useNavigate();
  const [email, setEmail] = createSignal("");
  const [password, setPassword] = createSignal("");
  const [password2, setPassword2] = createSignal("");
  // 0 - Email already associated with an account
  // 1 - Password mismatch
  // 2 - Internal error
  // 3 - Password does not meet security requirements
  const [error, setError] = createSignal(-1);
  const [loading, setLoading] = createSignal(false);

  // Password complexity enforcement
  const isLengthValid = createMemo(() => {
    const len = password().length;
    return len >= 8 && len <= 40;
  });
  const hasSpecialChar = createMemo(() => /[^A-Za-z0-9]/.test(password()));
  const hasUppercase = createMemo(() => /[A-Z]/.test(password()));
  const hasLowercase = createMemo(() => /[a-z]/.test(password()));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password() !== password2()) {
      setError(1);
      return;
    } else if (
      !isLengthValid() ||
      !hasSpecialChar() ||
      !hasUppercase() ||
      !hasLowercase()
    ) {
      setError(3);
      return;
    } else {
      setLoading(true);
      const res = await registerUser(email(), password());

      if (res) {
        setLoading(false);
        nav("/verify", { state: { email: email() } });
        return;
      } else if (res === false) {
        setLoading(false);
        setError(0);
        return;
      } else {
        setLoading(false);
        setError(2);
        return;
      }
    }
  };

  return (
    <div id="signup">
      <h2>Sign up for your account</h2>
      <form onSubmit={handleSubmit}>
        <div id="signup-form">
          <input
            class="login-input"
            placeholder="Email"
            onInput={(e) => setEmail(e.currentTarget.value)}
            required></input>
          <input
            class="login-input"
            type="password"
            placeholder="Password"
            onInput={(e) => setPassword(e.currentTarget.value)}
            required></input>
          <input
            class="login-input"
            type="password"
            placeholder="Confirm password"
            onInput={(e) => setPassword2(e.currentTarget.value)}
            required></input>
          <div id="password-requirements">
            <div class="column">
              <p class={isLengthValid() ? "subtext met" : "subtext"}>
                8–40 Characters
              </p>
              <p class={hasSpecialChar() ? "subtext met" : " subtext"}>
                Special character
              </p>
            </div>
            <div class="column">
              <p class={hasUppercase() ? "subtext met" : "subtext"}>
                Uppercase letter
              </p>
              <p class={hasLowercase() ? "subtext met" : "subtext"}>
                Lowercase letter
              </p>
            </div>
          </div>
          <button class="button1" style="width: 100px" type="submit">
            Sign Up
          </button>
          <Show when={error() === 1}>
            <p style="color: #878787; margin-top: -2px; margin-bottom: -2px;">
              Passwords do not match
            </p>
          </Show>
          <Show when={error() === 0}>
            <p style="color: #878787; margin-top: 0;">
              An account with this email address already exists.{" "}
              <span
                style={{ "text-decoration": "underline", cursor: "pointer" }}
                onClick={() => nav("/")}>
                Sign in
              </span>
            </p>
          </Show>
          <Show when={error() === 2}>
            <p style="color: #878787; margin-top: -2px; margin-bottom: -2px;">
              Something went wrong. Please try again.
            </p>
          </Show>
          <Show when={error() === 3}>
            <p class="subtext">
              Password does not meet minimum security requirements
            </p>
          </Show>
        </div>
      </form>

      <p
        style={{
          visibility: error() === -1 ? "visible" : "hidden",
        }}
        class="subtext-compact">
        Already have an account?{" "}
        <span
          style={{ "text-decoration": "underline", cursor: "pointer" }}
          onClick={() => nav("/")}>
          Sign in
        </span>
      </p>

      <Loading show={loading()} />
    </div>
  );
}
